import 'antd/dist/reset.css';
import React, { useEffect, useState, useMemo, useCallback } from 'react';
import {
    Row,
    Col,
    Avatar,
    Card,
    Select,
    Spin,
    Tabs,
    Button,
    Alert,
    Modal,
    Input,
    Tooltip,
    Radio,
    Tag,
} from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { useParams, useNavigate } from 'react-router-dom';
import moment from 'moment';
import { useAuth } from '../../Context';
import { useLocation } from 'react-router-dom';

import english from '../../Translations/English.json';
import hindi from '../../Translations/Hindi.json';
import malayalam from '../../Translations/Malayalam.json';

import {
    makeSelectFamily,
    makeSelectSlots,
    makeSelectRequesting,
    makeSelectDocDetails,
} from './Selectors';

import {
    getPatientDetails,
    getDoctorDetails,
    getDoctorSlots,
    updateScheduleSlotRequest,
} from './Actions';

import './style.css';
// import google from './google.png';
// import apple from './apple.png';
import FormItem from 'antd/es/form/FormItem';
import { BodyTextKey,TextDays } from '../CommonText';
const { TabPane } = Tabs;
const { Option } = Select;
import throttle from 'lodash.throttle';
import { makeSelectUpdatedScheduleData } from '../DoctorCampaign/Selectors';
// import { loginRedirectRequest } from '../Login/Actions';

export default function DoctorCampaign() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    
    const patientDetails = useSelector(makeSelectFamily());
    const timeSlots = useSelector(makeSelectSlots()) || [];
    const requesting = useSelector(makeSelectRequesting());
    const docDetails = useSelector(makeSelectDocDetails());
    const { getOrgFees, orgFees } = useAuth();
    const redirectfullUrl = location.pathname + location.search;

    if(redirectfullUrl){
        localStorage.setItem('redirectfullUrl',redirectfullUrl); 
    }

    const [patientName, setPatientName] = useState(
        Number(localStorage.getItem('PATIENT_IDS')) || null
    );
    const [visible, setVisible] = useState(false);
    const [field, setField] = useState('');
    const [defaultkey , setDefaultkey] = useState();
    const langid = localStorage.getItem('INTL') ? (localStorage.getItem('INTL')) : 'en';
    const langdata = langid && langid == 'en' ? english : langid == 'ma' ? malayalam : langid == 'hin' ? hindi : english;
    const [startDate, setStartDate] = useState();
    const [endDate, setEndDate] = useState();
    const [residenceModal,setResidenceModal] = useState();
    const [selectedResidence , setselectedResidence]  = useState('DOMESTIC');
    const applyViewportChange = 250;
    const [viewportWidth, setViewportWidth] = useState(0);
    // Function to handle viewport dimension changes
    const saveViewportDimensions = useCallback(
        throttle(() => {
            setViewportWidth(window.innerWidth);
        }, applyViewportChange),
        [applyViewportChange]
    );
    
    useEffect(() => {
        saveViewportDimensions(); 
        window.addEventListener('resize', saveViewportDimensions);
        
        return () => {
            window.removeEventListener('resize', saveViewportDimensions);
        };
    }, [saveViewportDimensions]);
    

    const { slug } = useParams();

    const decodedSlug = decodeURIComponent(slug);

    const withoutPrefix = decodedSlug.replace('dr-', '');

    const lastDashIndex = withoutPrefix.lastIndexOf('-');

    const namePart = withoutPrefix.substring(0, lastDashIndex);
    const id = withoutPrefix.substring(lastDashIndex + 1);

    const firstDashIndex = namePart.indexOf('-');

    const firstname = namePart.substring(0, firstDashIndex);
    const lastname = namePart.substring(firstDashIndex + 1);

    const consultationType = 'online';
    
    
    useEffect(() => {
        setStartDate(moment().format('YYYY-MM-DD'));
        setEndDate(moment().add(7, 'days').format('YYYY-MM-DD'));
    }, []);
    
    useEffect(()=>{
        getOrgFees(id, null);
    },[]);    


    useEffect(() => {
        if (!id) return;
        getOrgFees(id, null);
        localStorage.setItem('DOC_CAMPAIGN_ID', id);
        localStorage.setItem('CONSULT_DOCID', id);

        if (firstname) {
            localStorage.setItem('DOC_CAMPAIGN_NAME_FIRST', firstname);
            localStorage.setItem('DOC_CAMPAIGN_NAME_LAST', lastname);
            localStorage.setItem('IS_DOC_NAME', 'true');
            localStorage.setItem('IS_DOC_DEPT', 'false');
        }

        // if (params?.department) {
        //     localStorage.setItem('DOC_CAMPAIGN_DEPARTMENT', params.department);
        //     localStorage.setItem('IS_DOC_DEPT', 'true');
        // }

        if (sessionStorage.getItem('jwt')) {
            dispatch(getPatientDetails());
            localStorage.setItem('PATHCLICKED',`/doctor/${id}`
            );
        }

        dispatch(getDoctorDetails());
        dispatch(getDoctorSlots());

        if (localStorage.getItem('FLAG_UHID') === 'true') {
            setVisible(true);
        }

        setDefaultkey(1);
        setResidenceModal(true);

    }, [id, dispatch]);

    const selectPatientName = (value) => {
        // localStorage.setItem('REQ_PATIENT_ID', value);
        setPatientName(value);
    };   
  
    const  handleOk = () => {
    // eslint-disable-line
        dispatch({ type: 'UHID_REQUEST' });
        setVisible(false);
        localStorage.setItem('FLAG_UHID', false);
    };
    const handleCancel = () => {
    // eslint-disable-line
        dispatch({ type: 'UHID_REQUEST' });
        setVisible(false);
        localStorage.setItem('FLAG_UHID', false);
    };
    const handleField = (e) => {
    // eslint-disable-line
        setField(e.target.value);
        dispatch({ type: 'UHID_CHANGE', payload: field });
    };
    const tabBody = useMemo(() => {
        const startDate = moment();
        const days = Array.from({ length: 7 }, (_, i) =>
            startDate.clone().add(i, 'days')
        );

        return days.map((day) => {
            const dateStr = day.format('YYYY-MM-DD');
            let haveTimeSlots = false;

            timeSlots.forEach((s) => {
                if (s.date === dateStr) haveTimeSlots = true;
            });

            const morning = [];
            const afternoon = [];
            const evening = [];
            const now = moment();

            timeSlots.forEach((slot) => {
                if (slot.date !== dateStr) return;

                const slotTime = moment(`${slot.date} ${slot.time}`);
                const btn = (
                    <Button
                        key={slot.id}
                        style={{ margin: 5 }}
                        ghost
                        type="primary"
                        disabled={!slot.isVacant || slotTime.isBefore(now)}
                        onClick={() => checkToken(slot)}
                    >
                        {slotTime.format('hh:mm A')}
                    </Button>
                );

                const hour = slotTime.hour();
                if (hour < 12) morning.push(btn);
                else if (hour < 16) afternoon.push(btn);
                else evening.push(btn);
            });

            return (
                <TabPane tab={day.format('ddd MMM Do')} key={dateStr}>
                    {requesting ? (
                        <div style={{ textAlign: 'center', padding: '50px 0' }}>
                            <Spin size="large" />
                        </div>
                    ) : !haveTimeSlots && timeSlots.length > 0 ? (
                        <div style={{ padding: '12%', textAlign: 'center' }}>
                            SLOTS AVAILABLE ON{' '}
                            {moment(timeSlots[0].date).format('DD-MM-YYYY')}
                        </div>
                    ) : (
                        <div>
                            {morning.length > 0 && (
                                <div>
                                    <h2>
                                        <i style={{ margin: 10, color: '#fff566' }} className="fas fa-sun" />
                                        <TextDays text = {langdata.Morning ? langdata.Morning : 'Morning' } />
                                    </h2>
                                    <div style={{ margin: 10 }}>{morning}</div>
                                </div>
                            )}

                            {afternoon.length > 0 && (
                                <div>
                                    <h2>
                                        <i style={{ margin: 10, color: '#faad14' }} className="far fa-sun" />
                                        <TextDays text = {langdata.AfterNoon ? langdata.AfterNoon : 'AfterNoon'} />
                                    </h2>
                                    <div style={{ margin: 10 }}>{afternoon}</div>
                                </div>
                            )}

                            {evening.length > 0 && (
                                <div>
                                    <h2>
                                        <i style={{ margin: 10, color: '#fff566' }} className="fas fa-moon" />
                                        <TextDays text = {langdata.Evening ? langdata.Evening : 'Evening' } />
                                    </h2>
                                    <div style={{ margin: 10 }}>{evening}</div>
                                </div>
                            )}
                        </div>
                    )}

                    {/* 🚫 No slots at all */}
                    {timeSlots.length === 0 && (
                        <div style={{ padding: '12%', textAlign: 'center' }}>
                             NO SLOTS AVAILABLE
                        </div>
                    )}
                </TabPane>
            );
        });
    }, [timeSlots, requesting]);



    const handleNextResidence = () =>{
        setResidenceModal(false);
    };

    const handleResidencechange = (e) =>{
        setselectedResidence(e.target.value);
        localStorage.setItem('selectedResidence',e.target.value);
    };
    const updatedScheduleData = useSelector(makeSelectUpdatedScheduleData());
    
    const checkToken = (slot) => {
        
        if(!sessionStorage.getItem('jwt')){
            navigate('/login');
        }

                
        const consultationIn = selectedResidence ? selectedResidence : localStorage.getItem('selectedResidence');
        // const consultationType =   localStorage.getItem('CONSULT_TYPE');         
        let consultationTypeId;
        let orgFeesId;

        if(consultationIn && consultationType &&  orgFees){
            orgFees?.data.map((item)=>{
                if (consultationType === 'walk') {
                    if (item.feetype && item.feetype.feetype === 'HospitalInternational' && consultationIn === 'INTERNATIONAL') {
                        consultationTypeId = item.feeTypeId;
                        orgFeesId = item.id;
                    } else if (item.feetype && item.feetype.feetype === 'HospitalNRI' && consultationIn === 'NRI') {
                        consultationTypeId = item.feeTypeId;
                        orgFeesId = item.id;
                    } else if (item.feetype && item.feetype.feetype === 'Hospital' && consultationIn === 'DOMESTIC') {
                        consultationTypeId = item.feeTypeId;
                        orgFeesId = item.id;
                    }
                } else if (item.feetype && item.feetype.feetype === 'videoInternational' && consultationIn === 'INTERNATIONAL') {
                    consultationTypeId = item.feeTypeId;
                    orgFeesId = item.id;
                } else if (item.feetype && item.feetype.feetype === 'videoNRI' && consultationIn === 'NRI') {
                    consultationTypeId = item.feeTypeId;
                    orgFeesId = item.id;
                } else if (item.feetype && item.feetype.feetype === 'Video' && consultationIn === 'DOMESTIC') {               
                    consultationTypeId = item.feeTypeId;
                    orgFeesId = item.id;
                }
            });
        }
        
        if (patientName !== null) {
            
            const payload = {
                consultationTypeId : consultationTypeId,
                orgFeesId : orgFeesId,
                slotId: slot.id
            };
            
            dispatch(updateScheduleSlotRequest(payload));
            
        } 
   
    };

    useEffect(() => {
        if (!updatedScheduleData) return;

        const updateschedulepayload = {
            consultType: consultationType,
            doctorID: docDetails?.doctorsId,
            endDate,
            orgId: docDetails?.organisationsId,
            patientId: patientName,
            selectedResidence,
            startDate,
            updatedScheduleData
        };

        if (sessionStorage.getItem('jwt')) {
            consultationType === 'online'
                ? navigate('/selectloc', { state: { payload: updateschedulepayload } })
                : navigate('/scheduledetail');
        } else {
            navigate('/login');
        }
    }, [updatedScheduleData]);



    const requestAppointmentstate = {
        
        consultType : consultationType ,
        doctorID : docDetails?.doctorsId ,
        endDate : endDate ,
        orgId : docDetails?.organisationsId ,
        patientId : patientName ,
        selectedResidence : selectedResidence ,
        startDate : startDate,
    };
    
    return (
        <div style={{ marginTop: 10 }}>
            <Spin spinning={requesting} size="large">
                {docDetails ? (
                    <>
                        {/* Doctor Card */}
                        <Row align="center">
                            <Col  xs={24} sm={24} md={22} lg={18}>
                                <Card>
                                    <Row align="middle">
                                        <Col xs={24} sm={24} md={5} lg={6} xl={5} >
                                            <Avatar size={120} src={docDetails.profilephotourl} />
                                        </Col>
                                        <Col xs={24} sm={24} md={19} lg={18} xl={19} style={{ paddingTop: 10 }}>
                                            <h2>
                                                {docDetails.initials} {docDetails.firstName}{' '}
                                                {docDetails.lastName}
                                            </h2>
                                            <div>{docDetails.descriptions}</div>
                                            <div>{docDetails.specialization}</div>
                                            <div>{docDetails.orgname}</div>
                                        </Col>
                                    </Row>
                                </Card>
                            </Col>
                          
                        </Row>

                        {/* Patient Select */}

                        <Row justify="center" style={{ marginBottom: '20px' }}>
                            <Col xs={24} sm={24} md={22} lg={18}>
                                <Card>
                                    <Row align="middle" gutter={[16, 16]}>
          
                                        {/* Patient Name label */}
                                        <Col span={4} style={{
                                            marginTop: '3px',
                                            display: 'flex',
                                            justifyContent: 'flex-end'}}>
                                            <strong>
                                                <BodyTextKey
                                                    text={langdata.PatientnameC ? langdata.PatientnameC : 'Patient name :'}
                                                />
                                            </strong>
                                        </Col>

                                        {/* Patient Name select */}
                                        <Col span={5}>
                                            <Select
                                                style={{ width: '100%' }}
                                                placeholder="Select a patient"
                                                value={patientName}
                                                onChange={selectPatientName}
                                                disabled
                                            >
                                                {Array.isArray(patientDetails?.data) &&
                                               patientDetails?.data?.map((p) => (
                                                   <Option key={p.id} value={p.id}>
                                                       {p.firstName} {p.lastName}
                                                   </Option>
                                               ))}
                                            </Select>
                                        </Col>
                                        <Col span={1}>
                                                &nbsp;
                                        </Col>

                                        {/* Type of Residence label */}
                                        <Col  span={7} style={{
                                            marginTop: '3px',
                                            display: 'flex',
                                            justifyContent: 'flex-end'
                                        }}>
                                            <strong>
                                                <BodyTextKey
                                                    text={langdata.TypeofResidenceC ? langdata.TypeofResidenceC : 'Type of Residence :'}
                                                />
                                            </strong>
                                        </Col>

                                        {/* Type of Residence value */}
                                        <Col span={5}
                                            style={{
                                                marginTop: '3px',
                                            }}>
                                            {selectedResidence}
                                        </Col>
                                    </Row>

                                    {/* Tag centered */}
                                    <Row justify="center" style={{ marginTop: '15px' }}>
                                        <Col  span={24} 
                                            style={{
                                                display: 'flex',
                                                justifyContent: 'center',
                                                marginTop: '15px',
                                            }}>
                                            <Tag color="red">
                                                <span style={{ fontSize: viewportWidth < 560 ? '9px' : '' }}>
                                                    {langdata.AllTimeSlotsAreinIndianStandardTimeISTOnly
                                                        ? langdata.AllTimeSlotsAreinIndianStandardTimeISTOnly
                                                        : 'All Time Slots Are in Indian Standard Time(IST) Only. Please select the slot accordingly'}
                                                </span>
                                            </Tag>
                                        </Col>
                                    </Row>

                                </Card>
                            </Col>
                        </Row>



                        {/* Slots */}
                        <Row justify="center">
                            <Col xs={24} sm={24} md={22} lg={18}>
                                <Card>
                                    <Tabs  defaultActiveKey={defaultkey} tabPosition="top">
                                        {tabBody !== undefined ? tabBody : <TabPane tab={moment().format('ddd MMM Do')} key="1">Loading slots...</TabPane> }
                                    </Tabs> 
                                </Card>
                        
                                <Card style={{ marginTop: '10px', height: '50px' }}
                                    onClick={() => sessionStorage.getItem('jwt') ?  navigate('/newtimeslot',{
                                        state: {
                                            payload: requestAppointmentstate,
                                        },
                                    }): navigate('/login')}
                                >
                                    <div style={{ textAlign: 'center', marginTop: '-10px', color : '#1677ff', cursor : 'pointer' }}>
                                        {/* <Link to="/newtimeslot"> */}
                                        {langdata.RequestAppointment ? langdata.RequestAppointment : 'Request Appointment' }
                                        {/* </Link> */}
                                    </div>
                                </Card>
                            </Col>
                        </Row>
                    </>
                ) : (
                    <Alert message="No Doctor Found" type="warning" showIcon />
                )}

                <Modal
                    open={visible}
                    title="Have you visited this hospital before?"
                    onOk={handleOk}
                    onCancel={handleCancel}
                    footer={[
                        <Button key="back" onClick={handleCancel}>
                                Skip
                        </Button>,
                        <Button key="submit" type="primary" onClick={handleOk}>
                                Continue & Submit
                        </Button>,
                    ]}
                >
                    <div>
                        <h4>If YES! please enter your hospital registration number (UHID) </h4>
                        <Input placeholder="Enter Your UHID" onChange={handleField} />

                    </div>

                </Modal>

                {docDetails ? 
                    <Modal
                        open={residenceModal}
                        // onOk={this.handleOk}
                        // onCancel={handleCancel}
                        title={langdata.Pleaseselectyourtypeofresidence ? langdata.Pleaseselectyourtypeofresidence : 'Please select your type of residence'}
                        closable={false}
                        footer={[
                            <Button key="submit" type="primary" disabled ={!selectedResidence} onClick={handleNextResidence}>
                                {langdata.Next ? langdata.Next : 'Next'}
                            </Button>
                        // : null
                        ]}
                    >
                        <FormItem>
                            {/* <div style={{ marginBottom: '5px' }}>Please select your type of residence</div> */}
                            <Radio.Group
                            // value={props.selectedResidence}
                                onChange={handleResidencechange}
                            >
                                <Row style={{
                                    margin: '10px'
                                }}>
                                    <Col span={24} style={{
                                        margin: '5px'
                                    }}>
                                        <Tooltip title={langdata.PatientresidinginIndia ? langdata.PatientresidinginIndia : 'Patient residing in India'}>
                                            <Radio value='DOMESTIC' >{langdata.Domestic ? langdata.Domestic : 'Domestic' }</Radio>
                                        </Tooltip>
                                    </Col>
                                    <Col span={24} style={{
                                        margin: '5px'
                                    }}>
                                        <Tooltip title={langdata.Nonresidentindianpatients ? langdata.Nonresidentindianpatients : 'Non-resident indian patients'}>
                                            <Radio value='NRI' >{langdata.NRI ? langdata.NRI : 'NRI' }</Radio>
                                        </Tooltip>
                                    </Col>
                                    <Col span={24} style={{
                                        margin: '5px'
                                    }}>
                                        <Tooltip title={langdata.InternationalForiegnpatient ? langdata.InternationalForiegnpatient : 'International/Foriegn patient'}>
                                            <Radio value='INTERNATIONAL' >{langdata.International ? langdata.International : 'International' }</Radio>
                                        </Tooltip>
                                    </Col>
                                </Row>
                                {/* {isDomestic == true ?
                                :
                                <div>
                                    <Tooltip title={langdata.Nonresidentindianpatients ? langdata.Nonresidentindianpatients : 'Non-resident indian patients'}>
                                        <Radio value='NRI' >{langdata.NRI ? langdata.NRI : 'NRI' }</Radio>
                                    </Tooltip>
                                    <br />
                                    <br />
                                    <Tooltip title={langdata.InternationalForiegnpatient ? langdata.InternationalForiegnpatient : 'International/Foriegn patient' }>
                                        <Radio value='INTERNATIONAL' >{langdata.International ? langdata.International : 'International' }</Radio>
                                    </Tooltip>
                                </div>
                            } */}
                            </Radio.Group>
                        </FormItem>
                    </Modal>
                    : null
                }




                    
          
            </Spin>
        </div>
        
    );
}
